import React, { useEffect, useState } from 'react';
import Header from './Header';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);

  useEffect(() => {
    const updateCursorPosition = (e: MouseEvent) => {
      setCursorPosition({ x: e.clientX, y: e.clientY });
    };

    const handleMouseEnter = () => setIsHovering(true);
    const handleMouseLeave = () => setIsHovering(false);

    const interactiveElements = document.querySelectorAll('button, a, .glass-pill, .portfolio-item, .feature-card, .team-member');
    
    interactiveElements.forEach(el => {
      el.addEventListener('mouseenter', handleMouseEnter);
      el.addEventListener('mouseleave', handleMouseLeave);
    });

    document.addEventListener('mousemove', updateCursorPosition);

    return () => {
      document.removeEventListener('mousemove', updateCursorPosition);
      interactiveElements.forEach(el => {
        el.removeEventListener('mouseenter', handleMouseEnter);
        el.removeEventListener('mouseleave', handleMouseLeave);
      });
    };
  }, [children]); // Re-attach on page changes

  return (
    <div className="page">
      {/* Custom Cursor */}
       <div 
        className="cursor-dot"
        style={{
          left: `${cursorPosition.x}px`,
          top: `${cursorPosition.y}px`,
        }}
      />
      <div 
        className={`cursor-outline ${isHovering ? 'hovering' : ''}`}
        style={{
          left: `${cursorPosition.x}px`,
          top: `${cursorPosition.y}px`,
        }}
      />

      {/* Background Effects */}
      <div className="noise" />
      <div className="ambient-light" />
      
      <div className="service-bar desktop-only" style={{ position: 'fixed', top: 0, left: 0, right: 0, background: 'var(--bg-elevated)', borderBottom: '1px solid var(--border-subtle)', padding: '8px 0', zIndex: 1002 }}>
        <div className="shell" style={{ display: 'flex', justifyContent: 'center', gap: '30px', fontSize: '11px', fontWeight: '600', color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.1em' }}>
          <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}><div style={{ width: '6px', height: '6px', background: 'var(--accent)', borderRadius: '50%' }}></div> iOS & Android Apps</span>
          <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}><div style={{ width: '6px', height: '6px', background: 'var(--accent)', borderRadius: '50%' }}></div> Web Applications</span>
          <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}><div style={{ width: '6px', height: '6px', background: 'var(--accent)', borderRadius: '50%' }}></div> Desktop Software</span>
          <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}><div style={{ width: '6px', height: '6px', background: 'var(--accent)', borderRadius: '50%' }}></div> Enterprise ERP</span>
        </div>
      </div>

      <div className="layout-content-wrapper" style={{ paddingTop: window.innerWidth > 768 ? '34px' : '0px' }}>
        <Header />
      </div>
      
      <main style={{ minHeight: '80vh', paddingTop: '100px' }}>
        {children}
      </main>
      
      <Footer />

      {/* Scroll to top button */}
       <button 
          className="scroll-top" 
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="Scroll to top"
          style={{ display: window.scrollY > 300 ? 'flex' : 'none' }}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 15l-6-6-6 6"/>
          </svg>
        </button>
    </div>
  );
};

export default Layout;
